/* GEISS-MODIFIKATION (28.09.2026): Adventskalender nur allein bestellbar.
   Markup + Erkennung: snippets/geiss-kalender-mix.liquid (Box [data-geiss-kalender-mix]).
   Diese Datei wird global geladen (snippets/geiss-footer-legal.liquid), damit die Sperre
   auch nach dem Neu-Rendern des Cart-Drawers greift. */
(function () {
  if (window.geissKalenderMixInit) return;
  window.geissKalenderMixInit = true;

  var SELEKTOR = '[name="checkout"], .shopify-payment-button, .additional-checkout-buttons, [data-shopify="payment-button"]';

  function box() { return document.querySelector('[data-geiss-kalender-mix]'); }
  window.geissKalenderMixAktiv = function () { return !!box(); };

  /* Nur Checkout-Elemente des Warenkorbs, nicht die Kauf-Buttons auf Produktseiten. */
  function checkoutElemente() {
    return Array.prototype.filter.call(document.querySelectorAll(SELEKTOR), function (el) {
      return !el.closest('form[action*="/cart/add"]');
    });
  }

  function sperren() {
    checkoutElemente().forEach(function (el) {
      /* Nur anfassen, wenn noch nicht vollstaendig gesperrt. */
      if (el.classList.contains('geiss-km-gesperrt') &&
          el.getAttribute('aria-disabled') === 'true' &&
          el.hasAttribute('data-geiss-km-lock') &&
          (!('disabled' in el) || el.disabled)) return;
      el.classList.add('geiss-km-gesperrt');
      el.setAttribute('aria-disabled', 'true');
      el.setAttribute('data-geiss-km-lock', '1');
      if ('disabled' in el) el.disabled = true;
    });
  }

  function entsperren() {
    var gesperrte = document.querySelectorAll('[data-geiss-km-lock]');
    if (!gesperrte.length) return;
    gesperrte.forEach(function (el) {
      el.classList.remove('geiss-km-gesperrt');
      el.removeAttribute('aria-disabled');
      el.removeAttribute('data-geiss-km-lock');
      if ('disabled' in el) el.disabled = false;
    });
    /* Altersabfrage neu bewerten lassen, falls sie selbst sperren muss. */
    if (typeof window.geissAltersabfragePruefen === 'function') window.geissAltersabfragePruefen(null);
  }

  function anwenden() {
    if (box()) sperren(); else entsperren();
  }

  /* Letzte Absicherung: Checkout-Absenden abfangen, solange gemischt. */
  document.addEventListener('submit', function (e) {
    if (!box()) return;
    var form = e.target;
    var sub = e.submitter;
    var istCheckout = sub
      ? sub.name === 'checkout'
      : !!(form && form.querySelector && form.querySelector('[name="checkout"]') && !String(form.action).match(/\/cart\/add/));
    if (istCheckout) {
      e.preventDefault();
      e.stopPropagation();
      var b = box();
      if (b && b.scrollIntoView) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target.closest(SELEKTOR) : null;
    if (ziel && box() && !ziel.closest('form[action*="/cart/add"]')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /* Buttons "Zuerst ... bestellen": die jeweils andere Gruppe aus dem Warenkorb nehmen. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-geiss-km-behalten]') : null;
    if (!btn) return;
    var b = btn.closest('[data-geiss-kalender-mix]');
    if (!b) return;
    e.preventDefault();

    var behalten = btn.getAttribute('data-geiss-km-behalten');
    var entfernen = (b.getAttribute(behalten === 'kalender' ? 'data-andere' : 'data-kalender') || '')
      .split(',').filter(Boolean);
    if (!entfernen.length) return;

    var updates = {};
    entfernen.forEach(function (key) { updates[key] = 0; });
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      /* Fallback, falls der Drawer nicht neu rendert. */
      window.setTimeout(function () { if (box()) window.location.reload(); }, 1500);
    }).catch(function () { window.location.reload(); });
  });

  /* Sofort nach dem Neu-Rendern des Drawers reagieren ... */
  var timer;
  new MutationObserver(function () {
    if (timer) return;
    timer = window.setTimeout(function () { timer = null; anwenden(); }, 60);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  /* ... und zusaetzlich alle 400 ms nachziehen. Faengt u. a. ab, dass die Altersabfrage
     die Buttons per Attribut wieder freigibt. Kein Attribut-Observer (Schleifengefahr). */
  window.setInterval(anwenden, 400);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anwenden);
  } else {
    anwenden();
  }
})();
